<template>
    <div id="app">
        <nav
          class="navbar navbar-top navbar-expand-lg navbar-dark"
          :class="{'bg-success': env != 'staging', 'bg-danger': env == 'staging'}"
        >
            <div class="container">
                <router-link :to="{name: 'home'}" class="navbar-brand bar">
                    Plyler's Inventory
                </router-link>

                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarCollapse">
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item" :class="{active: route == 'create_part'}" v-if="isAuthenticated">
                            <router-link :to="{name: 'create_part'}" class="nav-link">
                                New Part
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{active: route == 'login'}" v-if="!isAuthenticated">
                            <router-link :to="{name: 'login'}" class="nav-link">
                                Login
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="isAuthenticated">
                            <a href="" class="nav-link" @click="logout()">
                                Log out
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

        <div class="container">
            <router-view/>
        </div>

        <div id="update-notification" class="d-none">
            <div class="alert alert-primary" role="alert" @click="refresh">
                A new version is available, click here to refresh.
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      route: 'list',
      env: process.env.VUE_APP_ENV || 'local',
    };
  },
  created() {
    if (this.isAuthenticated) {
      this.cacheWorkOrderTypes();
      this.cacheUsers();
    }
  },
  methods: {
    ...mapActions(['cacheWorkOrderTypes', 'cacheUsers']),
    async logout() {
      await this.$store.dispatch('logout');
      this.$router.push({ name: 'login' });
    },
    refresh() {
      window.location.reload();
    },
  },
  computed: mapState({ isAuthenticated: (state) => state.auth.isAuthenticated }),
  watch: {
    $route(to) {
      window.jQuery('#navbarCollapse').collapse('hide');
      this.route = to.name;
    },
    isAuthenticated() {
      if (this.isAuthenticated) {
        this.cacheWorkOrderTypes();
        this.cacheUsers();
      }
    },
  },
};
</script>

<style lang="scss">
</style>
